import {useTranslation} from 'react-i18next'
import {Button} from 'common/button'
import {Text} from 'common/text'
import {DISPLAY_NAME_MENU} from 'const/display_name_menu'
import {StyledMonthlyReviewThankYouModal} from './_styled'

// Popup thông báo sau khi Gửi đánh giá thành công
export const MonthlyReviewThankYouModal = ({onClose, ...props}) => {
  const {t} = useTranslation()

  return (
    <StyledMonthlyReviewThankYouModal {...props}>
      <div className="monthly-review-thank-you__container">
        <img
          className="monthly-review-thank-you__icon"
          src="/img/icon-star-review.png"
          width={150}
          height={100}
          alt=""
        />
        <Text
          as="h2"
          className="monthly-review-thank-you__title"
          fontSize={24}
          lineHeight={24}
          style={{width: '100%'}}
        >
          {t(DISPLAY_NAME_MENU.MONTHLY_REVIEW.THANK_TITLE)}
        </Text>
        <Text
          as="p"
          className="monthly-review-thank-you__description"
          color="#45495A"
          style={{width: '100%'}}
        >
          {t(DISPLAY_NAME_MENU.MONTHLY_REVIEW.THANK_DESCRIPTION)}
        </Text>
        <div className="monthly-review-thank-you__footer">
          <Button appearance="ghost" onClick={onClose}>
            {t(DISPLAY_NAME_MENU.MONTHLY_REVIEW.CLOSE)}
          </Button>
        </div>
      </div>
    </StyledMonthlyReviewThankYouModal>
  )
}
